import _ from 'lodash'; // eslint-disable-line
import Vue from 'vue';
// import VueTour from 'vue-tour';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';


// require('vue-tour/dist/vue-tour.css');
//
// Vue.use(VueTour);

Object.defineProperty(Vue.prototype, '_', { value: _ });
Object.defineProperty(Vue.prototype, 'router', { value: router });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');


document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
